<div
  [ngClass]="{ hide: hideFilter }"
  class="wheel-filter wheel-scanner-filter"
>
  <div
    (click)="$event.stopPropagation(); toggleFilter()"
    class="title-block"
  >
    <div class="title-container">
      <button
        (click)="$event.stopPropagation(); toggleFilter()"
        mat-icon-button
        class="close-open-item-btn component-btn"
      >
        <span
          [ngClass]="{ 'close-item': !this.hideFilter }"
          class="arrow-wrapper"
        >
          <div class="close-open-arrow"></div>
        </span>
      </button>

      <div class="title">
        <mat-icon
          [svgIcon]="'filter-icon'"
          class="l-icon"
        ></mat-icon>
        <span>Filters</span>
        @if (!filterCount) {
          <div class="filters-count"></div>
        }
      </div>
    </div>

    <div class="wheel-filters-presets-menu-container">
      <app-filters-presets-menu
        [selectedPresetId]="selectedFiltersPresetId"
        [predefinedFiltersList]="wheelFiltersPredefinedPresets"
        [customFiltersList]="wheelFiltersCustomPresets"
        (predefinedPresetsUpdated)="onPredefinedPresetsUpdated($event)"
        (customPresetsUpdated)="onCustomPresetsUpdated($event)"
        (presetSelected)="onSelectPreset($event)"
        (presetSettingsSaved)="onSavePresetSettings($event)"
        class="wheel-filters-presets-menu"
      ></app-filters-presets-menu>
    </div>

    @if (!filterCount) {
      <div class="actions">
        @if (!filterCount) {
          <button
            (click)="$event.stopPropagation(); resetFilters()"
            mat-button
            class="refresh"
          >
            <mat-icon
              [svgIcon]="'reset'"
              class="xl-icon"
            ></mat-icon>
            Reset
          </button>
        }
        <!--  button is temporarily hidden, "default" settings can be set in predefined preset  -->
        <!-- <button
        mat-button class="border-btn recommended-btn"
        (click)="$event.stopPropagation(); resetToRecommendedFilters()"
        [matTooltip]="'Set the scanner to the default settings that Markus and Mark use'"
        [matTooltipPosition]="'below'"
        [matTooltipHideDelay]="0"
        >
        Default
      </button> -->
      </div>
    }
  </div>

  <ul
    (click)="toggleFilter()"
    class="filter-input-data-duplicate"
  >
    <li>
      Flag: <span class="duplicate-data">{{ displayedFilterValues.flags }}</span>
    </li>
    <li>
      Min Strike: <span class="duplicate-data">{{ minStrikeReadableValues[wheelFilter.minStrike] }}</span>
    </li>
    <li>
      Dividends: <span class="duplicate-data">{{ dividends.value | titlecase }}</span>
    </li>
    @if (marketCapFrom.value || marketCapTo.value) {
      <li>
        Market Cap
        @if (marketCapFrom.value && marketCapTo.value) {
          <span>:</span>
        }
        <span class="duplicate-data">{{ displayedFilterValues.marketCap }}</span>
      </li>
    }
    @if (peRatioFrom.value || peRatioTo.value) {
      <li>
        P/E Ratio
        @if (peRatioFrom.value && peRatioTo.value) {
          <span>:</span>
        }
        <span class="duplicate-data">{{ displayedFilterValues.PERatio }}</span>
      </li>
    }
    @if (changeInPercentFrom.value || changeInPercentTo.value) {
      <li>
        Change in %
        @if (changeInPercentFrom.value && changeInPercentTo.value) {
          <span>:</span>
        }
        <span class="duplicate-data">{{ displayedFilterValues.changeInPercent }}</span>
      </li>
    }
    @if (displayedFilterValues.consensusRatings !== 'Any') {
      <li>
        Consensus Rating: <span class="duplicate-data">{{ displayedFilterValues.consensusRatings }}</span>
      </li>
    }
    @if (priceToAvgTargetFrom.value || priceToAvgTargetTo.value) {
      <li>
        Price to Avg Target
        @if (priceToAvgTargetFrom.value && priceToAvgTargetTo.value) {
          <span>:</span>
        }
        <span class="duplicate-data">{{ displayedFilterValues.priceToAvgTarget }}</span>
      </li>
    }
    <li>
      Sectors: <span class="duplicate-data">{{ sectorsFilterVisibleValues[sectors.value] }}</span>
    </li>
    <li>
      Expiration:
      <span class="duplicate-data">
        @switch (expiration.value) {
          @case ('All') {
            {{ expiration.value }}
          }
          @case ('Nearest') {
            {{ expirationDates[0] | date: 'MMM d, y' }}
          }
          @case ('Furthest') {
            {{ expirationDates[1] | date: 'MMM d, y' }}
          }
        }
      </span>
    </li>
    @if (strikeFrom.value || strikeTo.value) {
      <li>
        Strike
        @if (strikeFrom.value && strikeTo.value) {
          <span>:</span>
        }
        <span class="duplicate-data">{{ displayedFilterValues.strike }}</span>
      </li>
    }
    @if (roiFrom.value || roiTo.value) {
      <li>
        ROI %
        @if (roiFrom.value && roiTo.value) {
          <span>:</span>
        }
        <span class="duplicate-data">{{ displayedFilterValues.roi }}</span>
      </li>
    }
    @if (premiumFrom.value || premiumTo.value) {
      <li>
        Premium
        @if (premiumFrom.value && premiumTo.value) {
          <span>:</span>
        }
        <span class="duplicate-data">{{ displayedFilterValues.premium }}</span>
      </li>
    }
    @if (dropInPercentFrom.value || dropInPercentTo.value) {
      <li>
        Drop in %
        @if (dropInPercentFrom.value && dropInPercentTo.value) {
          <span>:</span>
        }
        <span class="duplicate-data">{{ displayedFilterValues.dropInPercent }}</span>
      </li>
    }

    @if (earningsBeforeExp.value !== earningBeforeExpValues.Any) {
      <li>
        Earnings:
        <span class="duplicate-data">{{ earningBeforeExpReadableValues[earningsBeforeExp.value] }}</span>
      </li>
    }
  </ul>

  <div
    (click)="$event.stopPropagation()"
    class="filters"
  >
    <div class="filters-group stock-group">
      <div class="input-item">
        <div class="form-group select-form flags form-label contain">
          <app-flags-filter
            [currentTheme]="currentTheme$ | async"
            [value]="wheelFilter.flags"
            (flagsSelected)="onChangeFlags($event)"
          ></app-flags-filter>
        </div>
      </div>

      <div class="input-item">
        <div class="form-group select-form form-label contain">
          <mat-form-field>
            <span
              class="top-label label-icon-container"
              mat-select-trigger
            >
              <span class="title">
                <span
                  [matTooltip]="minStrikeFilterHint"
                  [matTooltipPosition]="tooltipPosition"
                  [matTooltipHideDelay]="0"
                  class="underline"
                  >Min</span
                >
                Strike
              </span>
              <span class="top-label-result">
                <span class="summary">
                  {{ minStrikeReadableValues[wheelFilter.minStrike] }}
                </span>
                <mat-icon
                  [svgIcon]="'arrow-base_icon'"
                  class="small-icon"
                ></mat-icon>
              </span>
            </span>
            <mat-select
              [formControl]="minStrike"
              (selectionChange)="onFilterChange()"
              (focusout)="focusOutEvent($event)"
              (focus)="focusEvent($event)"
              (click)="$event.stopPropagation()"
              class="item-select"
            >
              <mat-option [value]="minStrikeFilterValues.AtLowestCloseInd">At Lowest Ind.</mat-option>
              <mat-option [value]="minStrikeFilterValues.Below">Below</mat-option>
              <mat-option [value]="minStrikeFilterValues.AtOrBellowLowestInd">At or Below Lowest Ind.</mat-option>
              <mat-option [value]="minStrikeFilterValues.AllStrikes">All</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="input-item">
        <div class="form-group select-form form-label contain">
          <mat-form-field>
            <span class="top-label label-icon-container">
              <span class="title">
                <span
                  [matTooltip]="dividendsFilterHint"
                  [matTooltipPosition]="'right'"
                  [matTooltipHideDelay]="0"
                  class="underline"
                  >Div</span
                >idends
              </span>
              <span class="top-label-result">
                <span class="summary">
                  {{ dividends.value | titlecase }}
                </span>
                <mat-icon
                  [svgIcon]="'arrow-base_icon'"
                  class="small-icon"
                ></mat-icon>
              </span>
            </span>
            <mat-select
              [formControl]="dividends"
              (selectionChange)="onFilterChange()"
              (focusout)="focusOutEvent($event)"
              (focus)="focusEvent($event)"
              (click)="$event.stopPropagation()"
              class="item-select"
            >
              <mat-option [value]="dividendsCount.All">All</mat-option>
              <mat-option [value]="dividendsCount.AtLeastOne">Yes</mat-option>
              <mat-option [value]="dividendsCount.None">No</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="input-item">
        <div class="form-group form-label contain">
          <!-- fix: use touchend and mouseup for IPad - it have an issue with select/focus -->
          <span
            [mat-menu-trigger-for]="marketCapModal"
            (menuOpened)="marketCapFromRef.select(); marketCapFromRef.focus()"
            (touchend)="marketCapFromRef.select(); marketCapFromRef.focus()"
            (mouseup)="marketCapFromRef.select(); marketCapFromRef.focus()"
            class="top-label label-icon-container"
          >
            <span class="title">
              <span
                [matTooltip]="marketCapFilterHint"
                [matTooltipPosition]="tooltipPosition"
                [matTooltipHideDelay]="0"
                class="underline"
                >Mar</span
              >ket Cap.
            </span>
            <span class="top-label-result">
              <span class="summary">
                {{ displayedFilterValues.marketCap }}
              </span>
              <mat-icon
                [svgIcon]="'arrow-base_icon'"
                class="small-icon"
              ></mat-icon>
            </span>
          </span>

          <mat-menu
            #marketCapModal="matMenu"
            class="wheel-scanner-mat-menu"
          >
            <div
              (click)="$event.stopPropagation(); $event.preventDefault()"
              class="menu-content"
            >
              <div class="wheel-scanner-mat-menu-heading">
                <span class="title">Market Cap.</span>
              </div>
              <div class="fields-wrapper">
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Greater than</mat-label>
                  <input
                    [id]="textInputKeys.MarketCapFrom"
                    [inputMask]="marketCapInputMask"
                    [formControl]="marketCapFrom"
                    [ngClass]="{ 'wheel-input': true, 'invalid-input': !isMarketCapFromValid }"
                    (input)="formatMarketCapValue(true)"
                    (keyup)="onFilterChange($event, textInputKeys.MarketCapFrom)"
                    (keydown.enter)="
                      $event.stopPropagation(); $event.preventDefault(); marketCapToRef.select(); marketCapToRef.focus()
                    "
                    (keydown.tab)="
                      $event.stopPropagation(); $event.preventDefault(); marketCapToRef.select(); marketCapToRef.focus()
                    "
                    (keydown.escape)="focusOutEvent($event, textInputKeys.MarketCapFrom)"
                    (focusout)="focusOutEvent($event, textInputKeys.MarketCapFrom)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #marketCapFromRef
                    autocomplete="off"
                    type="text"
                    maxlength="19"
                    matInput
                    spellcheck="false"
                  />
                </mat-form-field>
                <div class="fields-separator"></div>
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Less than</mat-label>
                  <input
                    [id]="textInputKeys.MarketCapTo"
                    [inputMask]="marketCapInputMask"
                    [formControl]="marketCapTo"
                    [ngClass]="{ 'wheel-input': true, 'invalid-input': !isMarketCapToValid }"
                    (input)="formatMarketCapValue(false)"
                    (keyup)="onFilterChange($event, textInputKeys.MarketCapTo)"
                    (keydown.tab)="
                      $event.stopPropagation();
                      $event.preventDefault();
                      marketCapFromRef.select();
                      marketCapFromRef.focus()
                    "
                    (keydown.enter)="
                      $event.stopPropagation();
                      $event.preventDefault();
                      marketCapFromRef.select();
                      marketCapModal.closed.emit()
                    "
                    (keydown.escape)="marketCapFromRef.select(); focusOutEvent($event, textInputKeys.MarketCapTo)"
                    (focusout)="focusOutEvent($event, textInputKeys.MarketCapTo)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #marketCapToRef
                    autocomplete="off"
                    type="text"
                    maxlength="19"
                    matInput
                    spellcheck="false"
                  />
                </mat-form-field>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>

      <div class="input-item">
        <div class="form-group form-label contain">
          <span
            [mat-menu-trigger-for]="peRatioModal"
            (menuOpened)="peRatioFromRef.select()"
            class="top-label label-icon-container"
          >
            <span class="title">
              <span
                [matTooltip]="PERatioFilterHint"
                [matTooltipPosition]="'below'"
                [matTooltipHideDelay]="0"
                class="underline"
                >P/E</span
              >
              Ratio
            </span>
            <span class="top-label-result">
              <span class="summary">
                {{ displayedFilterValues.PERatio }}
              </span>
              <mat-icon
                [svgIcon]="'arrow-base_icon'"
                class="small-icon"
              ></mat-icon>
            </span>
          </span>
          <mat-menu
            #peRatioModal="matMenu"
            class="wheel-scanner-mat-menu"
          >
            <div
              (click)="$event.stopPropagation(); $event.preventDefault()"
              class="menu-content"
            >
              <div class="wheel-scanner-mat-menu-heading">
                <span class="title">P/E Ratio</span>
              </div>
              <div class="fields-wrapper">
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Greater than</mat-label>
                  <input
                    [id]="textInputKeys.PERatioFrom"
                    [inputMask]="strikePriceInputMask"
                    [formControl]="peRatioFrom"
                    (keyup)="onFilterChange($event, textInputKeys.PERatioFrom)"
                    (keydown.enter)="$event.stopPropagation(); $event.preventDefault(); peRatioToRef.select()"
                    (keydown.tab)="$event.stopPropagation(); $event.preventDefault(); peRatioToRef.select()"
                    (keydown.escape)="focusOutEvent($event, textInputKeys.PERatioFrom)"
                    (focusout)="focusOutEvent($event, textInputKeys.PERatioFrom)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #peRatioFromRef
                    autocomplete="off"
                    matInput
                    min="0"
                    maxlength="10"
                    type="text"
                    class="wheel-input"
                  />
                </mat-form-field>
                <div class="fields-separator"></div>
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Less than</mat-label>
                  <input
                    [id]="textInputKeys.PERatioTo"
                    [inputMask]="strikePriceInputMask"
                    [formControl]="peRatioTo"
                    (keyup)="onFilterChange($event, textInputKeys.PERatioTo)"
                    (keydown.tab)="$event.stopPropagation(); $event.preventDefault(); peRatioFromRef.select()"
                    (keydown.enter)="
                      $event.stopPropagation();
                      $event.preventDefault();
                      peRatioFromRef.select();
                      peRatioModal.closed.emit()
                    "
                    (keydown.escape)="peRatioFromRef.select(); focusOutEvent($event, textInputKeys.PERatioTo)"
                    (focusout)="focusOutEvent($event, textInputKeys.PERatioTo)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #peRatioToRef
                    autocomplete="off"
                    matInput
                    min="0"
                    maxlength="10"
                    type="text"
                    class="wheel-input"
                  />
                </mat-form-field>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>

      <div class="input-item">
        <div class="form-group form-label contain input-hint">
          <span
            [matMenuTriggerFor]="changeInPercentModal"
            (menuOpened)="changeInPercentModalFromRef.select()"
            class="top-label label-icon-container"
          >
            <span class="title">
              <span
                [matTooltip]="changeInFilterHint"
                [matTooltipPosition]="'below'"
                [matTooltipHideDelay]="0"
                class="underline"
                >Cha</span
              >nge in %
            </span>
            <span class="top-label-result">
              <span class="summary">
                {{ displayedFilterValues.changeInPercent }}
              </span>
              <mat-icon
                [svgIcon]="'arrow-base_icon'"
                class="small-icon"
              ></mat-icon>
            </span>
          </span>
          <mat-menu
            #changeInPercentModal="matMenu"
            class="wheel-scanner-mat-menu"
          >
            <div
              (click)="$event.stopPropagation(); $event.preventDefault()"
              class="menu-content"
            >
              <div class="wheel-scanner-mat-menu-heading">
                <span class="title">Change in %</span>
              </div>
              <div class="fields-wrapper">
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Greater than</mat-label>
                  <input
                    [id]="textInputKeys.ChangeInPercentFrom"
                    [inputMask]="changeInInputMask"
                    [formControl]="changeInPercentFrom"
                    (keyup)="onFilterChange($event, textInputKeys.ChangeInPercentFrom)"
                    (keydown.enter)="
                      $event.stopPropagation(); $event.preventDefault(); changeInPercentModalToRef.select()
                    "
                    (keydown.tab)="
                      $event.stopPropagation(); $event.preventDefault(); changeInPercentModalToRef.select()
                    "
                    (keydown.escape)="focusOutEvent($event, textInputKeys.ChangeInPercentFrom)"
                    (focusout)="focusOutEvent($event, textInputKeys.ChangeInPercentFrom)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #changeInPercentModalFromRef
                    maxlength="7"
                    autocomplete="off"
                    matInput
                    class="wheel-input"
                  />
                </mat-form-field>
                <div class="fields-separator"></div>
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Less than</mat-label>
                  <input
                    [id]="textInputKeys.ChangeInPercentTo"
                    [inputMask]="changeInInputMask"
                    [formControl]="changeInPercentTo"
                    (keyup)="onFilterChange($event, textInputKeys.ChangeInPercentTo)"
                    (keydown.tab)="
                      $event.stopPropagation(); $event.preventDefault(); changeInPercentModalFromRef.select()
                    "
                    (keydown.enter)="
                      $event.stopPropagation();
                      $event.preventDefault();
                      changeInPercentModalFromRef.select();
                      changeInPercentModal.closed.emit()
                    "
                    (keydown.escape)="
                      changeInPercentModalFromRef.select(); focusOutEvent($event, textInputKeys.ChangeInPercentTo)
                    "
                    (focusout)="focusOutEvent($event, textInputKeys.ChangeInPercentTo)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #changeInPercentModalToRef
                    maxlength="7"
                    autocomplete="off"
                    matInput
                    class="wheel-input"
                  />
                </mat-form-field>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>

      <div class="input-item">
        <div class="form-group form-label contain">
          <div
            [matMenuTriggerFor]="consensusRatingsMenu"
            (menuOpened)="consensusRatingsMenu.focusFirstItem()"
          >
            <span class="top-label label-icon-container">
              <span class="title">Consensus Rating</span>
              <span class="top-label-result">
                <span class="summary">
                  {{ displayedFilterValues.consensusRatings }}
                </span>
                <mat-icon
                  [svgIcon]="'arrow-base_icon'"
                  class="small-icon"
                ></mat-icon>
              </span>
            </span>

            <mat-menu
              #consensusRatingsMenu="matMenu"
              class="mat-menu-default multiple-options-select-filter-menu"
            >
              <div
                mat-menu-item
                class="empty-symbol-option-menu-item"
              ></div>
              <div
                (click)="$event.stopPropagation()"
                class="multiple-options-select-filter-options-container"
              >
                @for (consensusRating of consensusRatingOptionsForFilter; track consensusRating.id) {
                  <mat-checkbox
                    [checked]="wheelFilter.consensusRatings?.includes(consensusRating.value)"
                    (change)="onChangeConsensusRatings(consensusRating)"
                    (click)="$event.stopPropagation()"
                    color="primary"
                    class="middle-checkbox"
                  >
                    {{ consensusRating.title }}
                  </mat-checkbox>
                }

                <button
                  (click)="$event.stopPropagation(); onChangeConsensusRatings(null)"
                  mat-button
                  class="reset-btn"
                >
                  <mat-icon
                    [svgIcon]="'reset'"
                    class="l-icon"
                  ></mat-icon>
                  Reset
                </button>
              </div>
            </mat-menu>
          </div>
        </div>
      </div>

      <div class="input-item">
        <div class="form-group form-label contain input-hint">
          <span
            [matMenuTriggerFor]="priceToAvgTargetModal"
            (menuOpened)="priceToAvgTargetFromRef.select()"
            class="top-label label-icon-container"
          >
            <span class="title">
              <span
                [matTooltip]="priceToAvgTargetFilterHint"
                [matTooltipPosition]="'below'"
                [matTooltipHideDelay]="0"
                class="underline"
                >Price to Avg</span
              >
              Target
            </span>
            <span class="top-label-result">
              <span class="summary">
                {{ displayedFilterValues.priceToAvgTarget }}
              </span>
              <mat-icon
                [svgIcon]="'arrow-base_icon'"
                class="small-icon"
              ></mat-icon>
            </span>
          </span>
          <mat-menu
            #priceToAvgTargetModal="matMenu"
            class="wheel-scanner-mat-menu"
          >
            <div
              (click)="$event.stopPropagation(); $event.preventDefault()"
              class="menu-content"
            >
              <div class="wheel-scanner-mat-menu-heading">
                <span class="title">Price to Avg Target</span>
              </div>
              <div class="fields-wrapper">
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Greater than</mat-label>
                  <input
                    [id]="textInputKeys.PriceToAvgTargetFrom"
                    [inputMask]="changeInInputMask"
                    [formControl]="priceToAvgTargetFrom"
                    (keyup)="onFilterChange($event, textInputKeys.PriceToAvgTargetFrom)"
                    (keydown.enter)="$event.stopPropagation(); $event.preventDefault(); priceToAvgTargetToRef.select()"
                    (keydown.tab)="$event.stopPropagation(); $event.preventDefault(); priceToAvgTargetToRef.select()"
                    (keydown.escape)="focusOutEvent($event, textInputKeys.PriceToAvgTargetFrom)"
                    (focusout)="focusOutEvent($event, textInputKeys.PriceToAvgTargetFrom)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #priceToAvgTargetFromRef
                    maxlength="7"
                    autocomplete="off"
                    matInput
                    class="wheel-input"
                  />
                </mat-form-field>
                <div class="fields-separator"></div>
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Less than</mat-label>
                  <input
                    [id]="textInputKeys.PriceToAvgTargetTo"
                    [inputMask]="changeInInputMask"
                    [formControl]="priceToAvgTargetTo"
                    (keyup)="onFilterChange($event, textInputKeys.PriceToAvgTargetTo)"
                    (keydown.tab)="$event.stopPropagation(); $event.preventDefault(); priceToAvgTargetFromRef.select()"
                    (keydown.enter)="
                      $event.stopPropagation();
                      $event.preventDefault();
                      priceToAvgTargetFromRef.select();
                      priceToAvgTargetModal.closed.emit()
                    "
                    (keydown.escape)="
                      priceToAvgTargetFromRef.select(); focusOutEvent($event, textInputKeys.PriceToAvgTargetTo)
                    "
                    (focusout)="focusOutEvent($event, textInputKeys.PriceToAvgTargetTo)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #priceToAvgTargetToRef
                    maxlength="7"
                    autocomplete="off"
                    matInput
                    class="wheel-input"
                  />
                </mat-form-field>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>

      <ng-container *appHideForUnavailableFeature="features.TradingLog">
        <div class="input-item">
          <div class="form-group select-form form-label contain">
            <mat-form-field>
              <span class="top-label label-icon-container">
                <span class="title"> Sectors </span>
                <span class="top-label-result">
                  <span class="summary">
                    {{ sectorsFilterVisibleValues[sectors.value] }}
                  </span>
                  <mat-icon
                    [svgIcon]="'arrow-base_icon'"
                    class="small-icon"
                  ></mat-icon>
                </span>
              </span>
              <mat-select
                [formControl]="sectors"
                (selectionChange)="onFilterChange()"
                (focusout)="focusOutEvent($event)"
                (focus)="focusEvent($event)"
                (click)="$event.stopPropagation()"
                class="item-select"
              >
                <mat-option [value]="sectorsValues.All">
                  {{ sectorsFilterVisibleValues[sectorsValues.All] }}
                </mat-option>
                <mat-option [value]="sectorsValues.ExcludePortfolioSectors">
                  {{ sectorsFilterVisibleValues[sectorsValues.ExcludePortfolioSectors] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="empty-input-item"></div>
        <div class="empty-input-item"></div>
      </ng-container>
    </div>

    <div class="filters-groups-separator"></div>

    <div class="filters-group options-group">
      <div class="input-item">
        <div class="form-group select-form form-label contain">
          <mat-form-field>
            <span class="top-label label-icon-container">
              Expiration
              <span class="top-label-result">
                <span class="summary">
                  @switch (expiration.value) {
                    @case ('All') {
                      {{ expiration.value }}
                    }
                    @case ('Nearest') {
                      {{ expirationDates[0] | date: 'MMM d, y' }}
                    }
                    @case ('Furthest') {
                      {{ expirationDates[1] | date: 'MMM d, y' }}
                    }
                  }
                </span>
                <mat-icon
                  [svgIcon]="'arrow-base_icon'"
                  class="small-icon"
                ></mat-icon>
              </span>
            </span>
            <mat-select
              [formControl]="expiration"
              (selectionChange)="flagSelect(); onFilterChange()"
              (focusout)="focusOutEvent($event)"
              (focus)="focusEvent($event)"
              (click)="$event.stopPropagation()"
              class="item-select"
            >
              <mat-option value="All">All</mat-option>
              @for (date of expirationDates; track date; let i = $index) {
                <mat-option
                  [value]="i === 0 ? 'Nearest' : 'Furthest'"
                  class="expiration-option"
                >
                  {{ date | date: 'MMM d, y' }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="input-item">
        <div class="form-group form-label contain input-hint">
          <span
            [matMenuTriggerFor]="strikeModal"
            (menuOpened)="strikeFromRef.select()"
            class="top-label label-icon-container"
          >
            Strike
            <span class="top-label-result">
              <span class="summary">
                {{ displayedFilterValues.strike }}
              </span>
              <mat-icon
                [svgIcon]="'arrow-base_icon'"
                class="small-icon"
              ></mat-icon>
            </span>
          </span>
          <mat-menu
            #strikeModal="matMenu"
            class="wheel-scanner-mat-menu"
          >
            <div
              (click)="$event.stopPropagation(); $event.preventDefault()"
              class="menu-content"
            >
              <div class="wheel-scanner-mat-menu-heading">
                <span class="title">Strike</span>
              </div>
              <div class="fields-wrapper">
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Greater than</mat-label>
                  <input
                    [id]="textInputKeys.StrikeFrom"
                    [inputMask]="strikePriceInputMask"
                    [formControl]="strikeFrom"
                    (keyup)="onFilterChange($event, textInputKeys.StrikeFrom)"
                    (keydown.enter)="$event.stopPropagation(); $event.preventDefault(); strikeToRef.select()"
                    (keydown.tab)="$event.stopPropagation(); $event.preventDefault(); strikeToRef.select()"
                    (keydown.escape)="focusOutEvent($event, textInputKeys.StrikeFrom)"
                    (focusout)="focusOutEvent($event, textInputKeys.StrikeFrom)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #strikeFromRef
                    min="0"
                    maxlength="10"
                    autocomplete="off"
                    matInput
                    class="wheel-input"
                  />
                </mat-form-field>
                <div class="fields-separator"></div>
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Less than</mat-label>
                  <input
                    [id]="textInputKeys.StrikeTo"
                    [inputMask]="strikePriceInputMask"
                    [formControl]="strikeTo"
                    (keyup)="onFilterChange($event, textInputKeys.StrikeTo)"
                    (keydown.tab)="$event.stopPropagation(); $event.preventDefault(); strikeFromRef.select()"
                    (keydown.enter)="
                      $event.stopPropagation();
                      $event.preventDefault();
                      strikeFromRef.select();
                      strikeModal.closed.emit()
                    "
                    (keydown.escape)="strikeFromRef.select(); focusOutEvent($event, textInputKeys.StrikeTo)"
                    (focusout)="focusOutEvent($event, textInputKeys.StrikeTo)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #strikeToRef
                    min="0"
                    maxlength="10"
                    autocomplete="off"
                    matInput
                    class="wheel-input"
                  />
                </mat-form-field>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>

      <div class="input-item roi-item">
        <div class="form-group form-label contain input-hint">
          <span
            [matMenuTriggerFor]="roiModal"
            (menuOpened)="roiFromRef.select()"
            class="top-label label-icon-container"
          >
            ROI %
            <span class="top-label-result">
              <span class="summary">
                {{ displayedFilterValues.roi }}
              </span>
              <mat-icon
                [svgIcon]="'arrow-base_icon'"
                class="small-icon"
              ></mat-icon>
            </span>
          </span>
          <mat-menu
            #roiModal="matMenu"
            class="wheel-scanner-mat-menu"
          >
            <div
              (click)="$event.stopPropagation(); $event.preventDefault()"
              class="menu-content"
            >
              <div class="wheel-scanner-mat-menu-heading">
                <span class="title">ROI</span>
              </div>
              <div class="fields-wrapper">
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Greater than</mat-label>
                  <input
                    [id]="textInputKeys.RoiFrom"
                    [inputMask]="strikePriceInputMask"
                    [formControl]="roiFrom"
                    (keyup)="onFilterChange($event, textInputKeys.RoiFrom)"
                    (keydown.enter)="$event.stopPropagation(); $event.preventDefault(); roiToRef.select()"
                    (keydown.tab)="$event.stopPropagation(); $event.preventDefault(); roiToRef.select()"
                    (keydown.escape)="focusOutEvent($event, textInputKeys.RoiFrom)"
                    (focusout)="focusOutEvent($event, textInputKeys.RoiFrom)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #roiFromRef
                    min="0"
                    maxlength="10"
                    autocomplete="off"
                    matInput
                    class="wheel-input"
                  />
                  <mat-hint [align]="'start'">Min: 5</mat-hint>
                </mat-form-field>
                <div class="fields-separator"></div>
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Less than</mat-label>
                  <input
                    [id]="textInputKeys.RoiTo"
                    [inputMask]="strikePriceInputMask"
                    [formControl]="roiTo"
                    (keyup)="onFilterChange($event, textInputKeys.RoiTo)"
                    (keydown.tab)="$event.stopPropagation(); $event.preventDefault(); roiFromRef.select()"
                    (keydown.enter)="
                      $event.stopPropagation(); $event.preventDefault(); roiFromRef.select(); roiModal.closed.emit()
                    "
                    (keydown.escape)="roiFromRef.select(); focusOutEvent($event, textInputKeys.RoiTo)"
                    (focusout)="focusOutEvent($event, textInputKeys.RoiTo)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #roiToRef
                    min="0"
                    maxlength="10"
                    autocomplete="off"
                    matInput
                    class="wheel-input"
                  />
                  <mat-hint [align]="'start'"></mat-hint>
                </mat-form-field>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>

      <div class="input-item">
        <div class="form-group form-label contain">
          <span
            [matMenuTriggerFor]="premiumModal"
            (menuOpened)="premiumFromRef.select()"
            class="top-label label-icon-container"
          >
            Premium
            <span class="top-label-result">
              <span class="summary">
                {{ displayedFilterValues.premium }}
              </span>
              <mat-icon
                [svgIcon]="'arrow-base_icon'"
                class="small-icon"
              ></mat-icon>
            </span>
          </span>
          <mat-menu
            #premiumModal="matMenu"
            class="wheel-scanner-mat-menu"
          >
            <div
              (click)="$event.stopPropagation(); $event.preventDefault()"
              class="menu-content"
            >
              <div class="wheel-scanner-mat-menu-heading">
                <span class="title">Premium</span>
              </div>
              <div class="fields-wrapper">
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Greater than</mat-label>
                  <input
                    [id]="textInputKeys.PremiumFrom"
                    [inputMask]="strikePriceInputMask"
                    [formControl]="premiumFrom"
                    (keyup)="onFilterChange($event, textInputKeys.PremiumFrom)"
                    (keydown.enter)="$event.stopPropagation(); $event.preventDefault(); premiumToRef.select()"
                    (keydown.tab)="$event.stopPropagation(); $event.preventDefault(); premiumToRef.select()"
                    (keydown.escape)="focusOutEvent($event, textInputKeys.PremiumFrom)"
                    (focusout)="focusOutEvent($event, textInputKeys.PremiumFrom)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #premiumFromRef
                    min="0"
                    maxlength="5"
                    autocomplete="off"
                    matInput
                    class="wheel-input"
                  />
                </mat-form-field>
                <div class="fields-separator"></div>
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Less than</mat-label>
                  <input
                    [id]="textInputKeys.PremiumTo"
                    [inputMask]="strikePriceInputMask"
                    [formControl]="premiumTo"
                    (keyup)="onFilterChange($event, textInputKeys.PremiumTo)"
                    (keydown.tab)="$event.stopPropagation(); $event.preventDefault(); premiumFromRef.select()"
                    (keydown.enter)="
                      $event.stopPropagation();
                      $event.preventDefault();
                      premiumFromRef.select();
                      premiumModal.closed.emit()
                    "
                    (keydown.escape)="premiumFromRef.select(); focusOutEvent($event, textInputKeys.PremiumTo)"
                    (focusout)="focusOutEvent($event, textInputKeys.PremiumTo)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #premiumToRef
                    min="0"
                    maxlength="5"
                    autocomplete="off"
                    matInput
                    class="wheel-input"
                  />
                </mat-form-field>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>

      <div class="input-item">
        <div class="form-group form-label contain input-hint">
          <span
            [matMenuTriggerFor]="dropInPercentModal"
            (menuOpened)="dropInPercentModalFromRef.select()"
            class="top-label label-icon-container"
          >
            <span class="title">
              <span
                [matTooltip]="
                  'It specifies how much the stock can drop before it hits the strike price at which you could get assigned.'
                "
                [matTooltipPosition]="'below'"
                [matTooltipHideDelay]="0"
                class="underline"
                >Drop</span
              >
              in %
            </span>
            <span class="top-label-result">
              <span class="summary">
                {{ displayedFilterValues.dropInPercent }}
              </span>
              <mat-icon
                [svgIcon]="'arrow-base_icon'"
                class="small-icon"
              ></mat-icon>
            </span>
          </span>
          <mat-menu
            #dropInPercentModal="matMenu"
            class="wheel-scanner-mat-menu"
          >
            <div
              (click)="$event.stopPropagation(); $event.preventDefault()"
              class="menu-content"
            >
              <div class="wheel-scanner-mat-menu-heading">
                <span class="title">Drop in %</span>
              </div>
              <div class="fields-wrapper">
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Greater than</mat-label>
                  <input
                    [id]="textInputKeys.DropInPercentFrom"
                    [inputMask]="strikePriceInputMask"
                    [formControl]="dropInPercentFrom"
                    (keyup)="onFilterChange($event, textInputKeys.DropInPercentFrom)"
                    (keydown.enter)="
                      $event.stopPropagation(); $event.preventDefault(); dropInPercentModalToRef.select()
                    "
                    (keydown.tab)="$event.stopPropagation(); $event.preventDefault(); dropInPercentModalToRef.select()"
                    (keydown.escape)="focusOutEvent($event, textInputKeys.DropInPercentFrom)"
                    (focusout)="focusOutEvent($event, textInputKeys.DropInPercentFrom)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #dropInPercentModalFromRef
                    min="0"
                    maxlength="6"
                    autocomplete="off"
                    matInput
                    class="wheel-input"
                  />
                </mat-form-field>
                <div class="fields-separator"></div>
                <mat-form-field
                  floatLabel="always"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <mat-label>Less than</mat-label>
                  <input
                    [id]="textInputKeys.DropInPercentTo"
                    [inputMask]="strikePriceInputMask"
                    [formControl]="dropInPercentTo"
                    (keyup)="onFilterChange($event, textInputKeys.DropInPercentTo)"
                    (keydown.tab)="
                      $event.stopPropagation(); $event.preventDefault(); dropInPercentModalFromRef.select()
                    "
                    (keydown.enter)="
                      $event.stopPropagation();
                      $event.preventDefault();
                      dropInPercentModalFromRef.select();
                      dropInPercentModal.closed.emit()
                    "
                    (keydown.escape)="
                      dropInPercentModalFromRef.select(); focusOutEvent($event, textInputKeys.DropInPercentTo)
                    "
                    (focusout)="focusOutEvent($event, textInputKeys.DropInPercentTo)"
                    (focus)="focusEvent($event); selectInputValue($event)"
                    #dropInPercentModalToRef
                    min="0"
                    maxlength="6"
                    autocomplete="off"
                    matInput
                    class="wheel-input"
                  />
                </mat-form-field>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>

      <div class="input-item">
        <div class="form-group select-form form-label contain">
          <mat-form-field>
            <span
              class="top-label label-icon-container"
              mat-select-trigger
            >
              <span class="title">
                <span
                  [matTooltip]="earningsBeforeExtFilterHint"
                  [matTooltipPosition]="tooltipPosition"
                  [matTooltipHideDelay]="0"
                  class="underline"
                  >Ear</span
                >nings
              </span>
              <span class="top-label-result">
                <span class="summary">
                  {{ earningBeforeExpReadableValues[wheelFilter.earningBeforeExp] }}
                </span>
                <mat-icon
                  [svgIcon]="'arrow-base_icon'"
                  class="small-icon"
                ></mat-icon>
              </span>
            </span>
            <mat-select
              [formControl]="earningsBeforeExp"
              (selectionChange)="onFilterChange()"
              (focusout)="focusOutEvent($event)"
              (focus)="focusEvent($event)"
              (click)="$event.stopPropagation()"
              class="item-select"
            >
              <mat-option [value]="earningBeforeExpValues.Any">
                {{ earningBeforeExpReadableValues[earningBeforeExpValues.Any] }}
              </mat-option>
              <mat-option [value]="earningBeforeExpValues.NotBeforeExp">
                {{ earningBeforeExpReadableValues[earningBeforeExpValues.NotBeforeExp] }}
              </mat-option>
              <mat-option [value]="earningBeforeExpValues.OnlyBeforeExp">
                {{ earningBeforeExpReadableValues[earningBeforeExpValues.OnlyBeforeExp] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>
